import {match} from 'ts-pattern';

export const getOptionType = (option: string) =>
  match<string, 'make' | 'modelFamily' | 'model'>(option.split('-')[1]?.split('_')[0])
    .with('MODELFAMILY', () => 'model')
    .with('MODELFAMILYGROUP', () => 'modelFamily')
    .otherwise(() => 'make');
